import { initialPlanListAdditionalFields, isTestAdditionalField } from '../constants/initialPlanListAdditionalFields';
import { IKnmPlanFilter } from '../interfaces/IKnmPlanFilter';
import { IPlanFilterExtraField } from '../interfaces/IPlanFilterExtraField';

export function mapFilterAdditionalFields(filter: IKnmPlanFilter, isUserTest: boolean): IPlanFilterExtraField[] {
  let items = initialPlanListAdditionalFields;

  if (isUserTest && !initialPlanListAdditionalFields.find(i => i.id === isTestAdditionalField.id)) {
    items = [...initialPlanListAdditionalFields, isTestAdditionalField];
  }

  return items.map<IPlanFilterExtraField>(field => {
    switch (field.id) {
      case 'period': {
        return {
          ...field,
          isSelected: filter.startDate.length > 0 || filter.endDate.length > 0,
        };
      }
      case 'isOnlyDeleted': {
        return {
          ...field,
          isSelected: Boolean(filter.isOnlyDeleted),
        };
      }
      case 'statuses': {
        return {
          ...field,
          isSelected: Boolean(filter.erknmStatuses?.length) || Boolean(filter.statuses?.length),
        };
      }
      case 'id': {
        return {
          ...field,
          isSelected: Boolean(filter.id),
        };
      }
      case 'isTest': {
        return {
          ...field,
          isSelected: Boolean(filter.isTest),
        };
      }
      default:
        return field;
    }
  });
}
